import { useAnalytics, useFirebase } from "@popped/popshap-kiosk-components";
import React, { FC } from "react";
import { useLocation } from "react-router-dom";
import Popup from "../components/Popup";
//import { suppliers } from "./suppliers"
//import { collateral } from "./collateral"
const DataContext =
  React.createContext<
    | {
      config: any;
      homePage: any;
	    location: any;
      addFlow: any;
      logFlow: any;
    }
    | undefined
  >(undefined);

export const DataProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const firebase = useFirebase();
  const [config, setConfig] = React.useState<any>(undefined);
  const [location, setLocation] = React.useState<string | null>("1");
  const [showPopup, setShowPopup] = React.useState(false);
  const { pathname } = useLocation();
  const [homePage, setHomePage] = React.useState<any>(undefined);
  const [flow, setFlow] = React.useState<string[]>([]);
  const { logEvent } = useAnalytics();
  const _logEvent = React.useCallback(async (type: string, value: string, clicks?: any) => {
      await logEvent(type, value, { kiosk: location, clicks: clicks })
  }, [logEvent, location]) //Add kiosk: location, and [location] for multiple kiosks
  React.useEffect(() => {
    if (firebase) {
      const unsub1 = firebase!.getItem("", (res) => { setConfig(res?.config);});
      return () => {
        unsub1();
      };
    }
  }, [firebase]);

  
  const addFlow = (action: string) => {
    setFlow((currentFlow: string[]) => [...currentFlow, action]);
  }
  const logFlow = (action?: string) => {
    if(flow.length > 0){
      if(action)
        _logEvent('flow', [...flow, action].join(", "), flow.length+1)
      else
      _logEvent('flow', flow.join(", "), flow.length)
      setFlow(()=>[]);
    }
  }
  React.useEffect(()=>{
    if(pathname === '/')
      logFlow();
  }, [pathname])

  return (
    <DataContext.Provider
      value={{
        config,
        homePage,
        addFlow,
        logFlow,
        location
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => React.useContext(DataContext);
